/* eslint-disable react/prop-types -- this codebase does not use propTypes (see CLAUDE.md). */
import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useStore } from "../contexts/StoreContext";
import { isStartFlow, markStartFlow } from "../utils/onboardingFlow";
import { listPasses } from "../pages/start/api";

function startTarget(search) {
  const payment = new URLSearchParams(search).get("payment");
  const path = payment === "success" ? "/start/done" : payment === "cancel" ? "/start/plan" : "/start";
  return `${path}${search}`;
}

// Wraps the /setup routes. People who came in through /start never see the
// /setup wizard: Stripe's return (/setup?payment=success|cancel, which the
// backend hard-codes), setup reminder emails and the dashboard's Setup link
// all send them back into /start. Everyone else gets /setup exactly as before,
// rendered straight away with the URL untouched.
//
// The browser mark is lost on another browser (a reminder email opened in
// Mail or Safari, a desktop) and on sign-out, so a store whose card /start made
// (pass.onboarding.flow) re-marks the browser. That check runs in the
// background and never delays /setup for anyone else.
export default function StartFlowGuard({ children }) {
  const location = useLocation();
  const { selectedStore } = useStore();
  const marked = isStartFlow();
  const storeId = selectedStore?.id;

  const { data: passes } = useQuery({
    queryKey: ["start", "passes", storeId],
    queryFn: () => listPasses(storeId),
    enabled: !marked && !!storeId,
    staleTime: Infinity,
    retry: false,
  });
  const madeByStart = !marked && (passes || []).some((p) => p?.pass?.onboarding?.flow === "start");

  useEffect(() => {
    if (madeByStart) markStartFlow();
  }, [madeByStart]);

  if (marked || madeByStart) return <Navigate to={startTarget(location.search)} replace />;
  return children;
}
